import { StructureEditorConfig } from '@Pages/StructureEditor/StructureEditorConstants';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { getDefaultServices, MarvinConfig } from '@Constants/MarvinConstants';
import StructureEditorInterface from '../StructureEditorInterface';
import { POST_MESSAGE_TYPES, MarvinInstancePostMessageWrapper } from './MarvinInstancePostMessageWrapper';

export default class MarvinController extends StructureEditorInterface {
  marvinInstancePostMessageWrapper = null;

  state = null;

  onLoadedCallbacks = [];

  onChangeCallbacks = [];

  constructor(iframe, props = {}) {
    super();

    if (!iframe) {
      Logger.error('MarvinService: Required option iframe is not exists.');
    }

    this.state = this._init(iframe, props);
  }

  async _init(iframe, props) {
    // Editor custom init promise
    await new Promise((resolve, reject) => {
      iframe.addEventListener('load', async () => {
        this.marvinInstancePostMessageWrapper = new MarvinInstancePostMessageWrapper(iframe.contentWindow);

        const { editMode } = props;
        const configs = {
          license: RequestUrls.marvinLicense.url,
          services: getDefaultServices(),
          templateUrl: MarvinConfig.templateUrl,
          toolbars: editMode ? StructureEditorConfig.toolbar.customSearch : StructureEditorConfig.toolbar.only3D,
        };

        const ready = await this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.customInit, configs);
        if (ready) {
          resolve();
        } else {
          reject();
        }
      });
    });

    // Loaded and onchange callbacks
    this.onLoadedCallbacks.forEach((clbck) => {
      clbck.apply(null);
    });
    this.marvinInstancePostMessageWrapper.sendPostMessageCallback(POST_MESSAGE_TYPES.on.molchange, null, async () => {
      const isEditorEmpty = await this.isEmpty();
      this.onChangeCallbacks.forEach((clbck) => {
        clbck.apply(null, [isEditorEmpty]);
      });
    });
  }

  async importStructure(data) {
    await this.state;
    const format = MarvinConfig.exportFormat;
    return this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.importStructure, [format, data]);
  }

  async getData() {
    await this.state;
    const [data, preview] = await Promise.all([
      this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.exportStructure, [
        MarvinConfig.exportFormat,
        MarvinConfig.defaultImageExporterOptions,
      ]),
      this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.exportStructure, [
        MarvinConfig.defaultImageExporterOptions.imageType,
        MarvinConfig.defaultImageExporterOptions,
      ]),
    ]);
    return { data, preview };
  }

  async loadStructure(structure) {
    await this.state;
    return this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.pasteStructure, [null, structure]);
  }

  async isEmpty() {
    await this.state;
    return this.marvinInstancePostMessageWrapper.sendPostMessagePromise(POST_MESSAGE_TYPES.isEmpty);
  }

  async clear() {
    await this.state;
    return this.marvinInstancePostMessageWrapper.sendPostMessage(POST_MESSAGE_TYPES.clear);
  }

  onChange(callback) {
    this.onChangeCallbacks.push(callback);
    return () => {
      this.onChangeCallbacks = this.onChangeCallbacks.filter((clbck) => clbck !== callback);
    };
  }

  onLoaded(callback) {
    this.onLoadedCallbacks.push(callback);
    return () => {
      this.onLoadedCallbacks = this.onLoadedCallbacks.filter((clbck) => clbck !== callback);
    };
  }
}
